import { forwardRef } from 'react'

import { TrendPickBookingIcon, CommonPayIcon } from '@local/assets/icons'

import { convertIntoDisplayCount } from '@web/libs/formatter'
import Clickable from '@web/ui/components/Clickable'
import { RecentBookingOrderTab } from '@web/ui/pages/home/components/Sections/RecentOrderAndBookingSection/constant'

import styles from './RecentOrderAndBookingSection.module.scss'
import ThumbnailContent, { ThumbnailContentPropsItem } from '../../ThumbnailContent'

export interface UIRecentOrderAndBookingCardProps extends ThumbnailContentPropsItem {
  /**
   * 예약/주문 횟수
   */
  completeCount: number
  /**
   * 예약/주문 가능 여부
   */
  isAlive: boolean
  /**
   * 예약/주문 타입
   */
  type: RecentBookingOrderTab
  /**
   * 카드 클릭시 콜백
   */
  onClick?: () => void
  /**
   * 예약/주문하기 클릭시 콜백
   */
  onAction?: () => void
  /**
   * 몇개 이후로 축약형 e.g. `999+` 표현할 것인지 기본값 999
   */
  maxDisplayCount?: number
  /**
   * 카드 클릭 코드
   */
  actionClickCode?: string
  /**
   * 이미지 클릭 코드
   */
  thumbnailClickCode?: string
  /**
   * 순위
   */
  nClickRank?: number
  /**
   * 장소 아이디
   */
  nClickPlaceId?: string
  /**
   * 비즈니스 아이디
   */
  nClickBusinessId?: string
}

const UIRecentOrderAndBookingCard = forwardRef<HTMLLIElement, UIRecentOrderAndBookingCardProps>(
  function UIRecentOrderAndBookingCard(
    {
      completeCount,
      isAlive,
      type,
      onAction,
      maxDisplayCount = 999,
      actionClickCode,
      thumbnailClickCode,
      nClickBusinessId,
      nClickPlaceId,
      nClickRank,
      ...item
    },
    ref,
  ) {
    return (
      <li className={styles.list_item} ref={ref}>
        <ThumbnailContent
          item={item}
          onClick={item.onClick}
          clickCode={thumbnailClickCode}
          clickRank={nClickRank}
          clickBusinessId={nClickBusinessId}
          clickPlaceId={nClickPlaceId}
          extra={
            completeCount > 1 && (
              <div className={styles.label}>
                {convertIntoDisplayCount({ count: completeCount, maxDisplayCount })}회 {type}
              </div>
            )
          }
        >
          {/* 버튼 영역 */}
          <div className={styles.btn_area}>
            <Clickable
              className={styles.btn}
              aria-disabled={!isAlive}
              onClick={onAction}
              nClickCode={actionClickCode}
              nClickBusinessId={nClickBusinessId}
              nClickRank={nClickRank}
              nClickPlaceId={nClickPlaceId}
            >
              {type === '주문' ? (
                <CommonPayIcon className={styles.icon_btn} aria-hidden="true" />
              ) : (
                <TrendPickBookingIcon className={styles.icon_btn} aria-hidden="true" />
              )}
              {type}하기
            </Clickable>
          </div>
        </ThumbnailContent>
      </li>
    )
  },
)

export default UIRecentOrderAndBookingCard
